import i18n from 'i18next';

import { HousingDurationOption } from '../types/HousingDurationOption';
import { ONE_YEAR_IN_MONTHS_AS_STRING } from './oneYear';
import { TWO_YEARS_IN_MONTHS_AS_STRING } from './twoYears';

export const monthsAtResidenceOptions: HousingDurationOption[] = [
  {
    name: i18n.t('residenceDuration.moreThan2Years'),
    value: TWO_YEARS_IN_MONTHS_AS_STRING,
  },
  {
    name: i18n.t('residenceDuration.lessThan2Years'),
    value: ONE_YEAR_IN_MONTHS_AS_STRING,
  },
];
